export default __webpack_public_path__ + "static/media/art_wheel_poll.5dc77699.svg";